import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ForOFor from './../container/forOFor';
import SectionDetail from './sectionDetail';
import { fetchSectionDetail } from './../actions.js';
import { getSection } from './../../ui/src/actions.js';
import { getProp } from '../../ui/src/utilities';

class SectionContentItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const idFromUrl = this.getUrlId(this.props);
    if (idFromUrl) {
      // direct access
      const locationFromUrl = this.getUrlLocation(this.props);
      this.init(idFromUrl, locationFromUrl ? locationFromUrl : null);
    } else {
      // indirect access
      this.init(
        this.props.id,
        this.props.locationId ? this.props.locationId : null
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    const idFromUrl = this.getUrlId(nextProps);
    if (idFromUrl) {
      // direct access
      const locationFromUrl = this.getUrlLocation(nextProps);
      if (
        idFromUrl !== this.getUrlId(this.props) ||
        locationFromUrl !== this.getUrlLocation(this.props)
      ) {
        this.init(idFromUrl, locationFromUrl ? locationFromUrl : null);
      }
    } else {
      // indirect access
      if (
        nextProps.id !== this.props.id ||
        nextProps.locationId !== this.props.locationId
      ) {
        this.init(
          nextProps.id,
          nextProps.locationId ? nextProps.locationId : null
        );
      }
    }
  }

  getUrlId(props) {
    let id = getProp(props, 'params.id', null);
    if (id !== null) {
      return Number(id);
    }
    return null;
  }

  getUrlLocation(props) {
    return getProp(props, 'location.query.lokalita', null);
  }

  init(id, locationId = null) {
    if (id) {
      this.props.dispatch(getSection(process.env.REACT_APP_CONTENT_SPACE, id));
      this.props.dispatch(fetchSectionDetail(id, locationId));
    }
  }

  render() {
    const idFromUrl = this.getUrlId(this.props);
    const locationFromUrl = this.getUrlLocation(this.props);
    const id = idFromUrl || this.props.id;
    const locationId = locationFromUrl || this.props.locationId;
    if (!id || this.props.isNotFound) {
      return <ForOFor />;
    }
    return (
      <div>
        <SectionDetail id={id} locationId={locationId} />
      </div>
    );
  }
}

SectionContentItem.fetchData = ({
  store,
  renderProps: { location, params }
}) => {
  let id = getProp(params, 'id', null);
  if (id !== null) {
    return store.dispatch(getSection('radiokosice', id));
  }
  return Promise.resolve();
};

SectionContentItem.propTypes = {
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.number,
  locationId: PropTypes.string,
  isNotFound: PropTypes.bool
};

export default connect(state => {
  return {
    isNotFound: state.sections.httpStatus === 404
  };
})(SectionContentItem);



// WEBPACK FOOTER //
// ./src/app/container/sectionContentItem.js